// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","footerInner":"Footer_footerInner__2VsGn","info":"Footer_info__3yXvo","navigation":"Footer_navigation__3g1hT","link":"Footer_link__Xabb2"};